import "./main.scss";
import { HHDS } from "@hhh/hhh-design-system/lib/hhds";

import './aos';

HHDS.register(true, "plugin");
document.body.classList.add('loaded');
